import { FC } from "react";
import { JokeModalProps } from "./types";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Button,
  Box,
} from "@chakra-ui/react";
import { useFetchJoke } from "../../../application/api";

export * from "./types";

export const JokeModal: FC<JokeModalProps> = (props) => {
  const { isOpen, onClose } = props;

  const { joke, loading, error, refetch } = useFetchJoke(isOpen);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Here's a good one</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {error && (
              <Box>
                Sorry I'm out of jokes.
                <br />
                Try again later
              </Box>
            )}
            {loading && <Spinner />}
            {!error && !loading ? (
              <Box
                whiteSpace="break-spaces"
                dangerouslySetInnerHTML={{ __html: joke?.joke as string }}
              />
            ) : null}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="white" mr={3} color="black" onClick={onClose}>
              I've had enough
            </Button>
            <Button
              colorScheme={"orange"}
              bg={"orange.400"}
              _hover={{ bg: "orange.500" }}
              onClick={refetch}
            >
              Another !! :'D
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
